import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import KitchenDispatchNewEditForm from '../kitchen-dispatch-new-edit-form';

export default function KitchenDispatchOrderCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new dispatch order"
        links={[
          {
            name: 'Dispatch Orders',
            href: paths.dashboard.kitchen.dispatch.root(),
          },
          { name: 'Create a new dispatch order' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <KitchenDispatchNewEditForm />
    </Container>
  );
}
